var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"font-bold main-list-title text-dark select-none"},[_vm._t("default"),(!_vm.hideAdd)?_c('span',{staticClass:"cursor-pointer hover:text-warning",class:_vm.trackClass,on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._v(" +")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }